
import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import {GroupActions, GroupStore} from '../types';

const initialState: Omit<GroupStore, keyof GroupActions> = {
    groups: [],
    // @ts-ignore
    activeGroup: null,
    accessLevels: [],
    selectedAccessLevels: [],
    searchTerm: '',
    actionMode: 'view',
    isModalOpen: false,
    isLoading: false,
    error: null,
};

export const useGroupStore = create<GroupStore>()(
    devtools(
        (set) => ({
            ...initialState,

            setGroups: (groups) =>
                set({ groups }),

            setActiveGroup: (group) =>
                // @ts-ignore
                set({ activeGroup: group }),

            setAccessLevels: (accessLevels) =>
                // @ts-ignore
                set({ accessLevels }),

            setSelectedAccessLevels: (accessLevels) =>
                // @ts-ignore
                set({ selectedAccessLevels: accessLevels }),

            setSearchTerm: (term) =>
                set({ searchTerm: term }),

            setActionMode: (mode) =>
                // @ts-ignore
                set({ actionMode: mode }),

            setModalOpen: (isOpen) =>
                // @ts-ignore
                set({ isModalOpen: isOpen }),

            resetState: () =>
                set(initialState),
        }),
        { name: 'GroupStore' }
    )
);